import type {
  Club,
  ClubAutocompleteItem,
  ClubMembershipRequest,
  CreateClubPayload,
  UpdateClubPayload,
  GetClubsParams,
} from '@shared/types/entities';

import { api } from './client';
import { type PaginatedResponse, buildQuery } from './types';

export type { Club, ClubAutocompleteItem, ClubMembershipRequest, CreateClubPayload, UpdateClubPayload, GetClubsParams };

export async function getClubsApi(params?: GetClubsParams): Promise<PaginatedResponse<Club>> {
  return api.get(`/clubs${buildQuery(params as Record<string, unknown>)}`);
}

export async function getClubApi(id: number): Promise<Club> {
  return api.get(`/clubs/${id}`);
}

export async function createMembershipRequestApi(
  clubId: number,
  data?: { message?: string },
): Promise<ClubMembershipRequest> {
  return api.post(`/clubs/${clubId}/membership-request`, data ?? {});
}

export async function getMyMembershipRequestApi(): Promise<ClubMembershipRequest | null> {
  return api.get('/clubs/membership-requests/my');
}

export async function autocompleteClubsApi(q: string): Promise<ClubAutocompleteItem[]> {
  return api.get(`/clubs/autocomplete?q=${encodeURIComponent(q)}`);
}

export async function createClubClaimApi(clubId: number): Promise<{ id: number }> {
  return api.post(`/clubs/${clubId}/claim`, {});
}

export async function updateClubContactApi(
  clubId: number,
  data: { email?: string; phone?: string },
): Promise<{ id: number; email: string | null; phone: string | null }> {
  return api.patch(`/clubs/${clubId}/contact`, data);
}

export async function sendClubMessageApi(
  clubId: number,
  data: { fullName: string; message: string; hcaptchaToken: string },
): Promise<void> {
  return api.post(`/clubs/${clubId}/message`, data);
}
